<div class="sticky-bars-container" #stickyBars>
    <ng-content></ng-content>
</div>
<!--page end to calculate the end of scroll-->
<div class="page-end" #pageEnd>
</div>
